import {
    SEAT_SIZE,
    SPACING_VERTICAL,
    SPACING_HORIZONTAL,
    DUPLICATE_OFFSET,
} from '%paysera_seat_selection/js/seatSelection/config/defaults';

export default function getSectorDuplicationData(sectorObject) {
    return {
        x: sectorObject.transformation.translation.x + DUPLICATE_OFFSET,
        y: sectorObject.transformation.translation.y + DUPLICATE_OFFSET,
        seatsCount: Math.ceil(sectorObject.compiled.polygon.dimensions.width / (SEAT_SIZE + SPACING_VERTICAL)),
        rowsCount: Math.ceil(sectorObject.compiled.polygon.dimensions.height / (SEAT_SIZE + SPACING_HORIZONTAL)),
    };
}
